import { MyAccountLinks } from 'src/main/constants/constants';
import { ActionableIcon } from '@/app_components/common/ActionableIcon';
import { BasicPopover } from '@/app_components/common/BasicPopover';
import { SignOutButton } from '@/app_components/common/header/SignOutButton';
import { Icon } from '@/app_components/common/Icon';
import { Link } from '@/app_components/common/Link';
import { ButtonV2 } from '@/app_components/ui/ButtonV2';
import { ContentPlacement } from '@/app_lib/types/analytics';
import { cn } from '@/app_lib/utils/utils';

interface AccountMenuProps {
  disabled?: boolean;
}

export const AccountMenu = ({ disabled = false }: AccountMenuProps) => {
  const trigger = (
    <div data-cy={ContentPlacement.AccountDropdown}>
      <ActionableIcon
        as='button'
        className='-mr-[10px] lg:mr-0'
        data-cy={ContentPlacement.UserIconButton}
        disabled={disabled}
      >
        <Icon
          className='md:hidden'
          icon='CircleUser'
        />
      </ActionableIcon>
      <ButtonV2
        aria-disabled={disabled}
        className={cn('gap-2 items-center hidden md:flex')}
        data-cy={ContentPlacement.MyAccountLink}
        href='/my-account/'
        isTertiary
      >
        My Account
        <Icon
          className='group-hover:rotate-180'
          icon='ChevronDown'
        />
      </ButtonV2>
    </div>
  );

  const content = (
    <ul className='flex flex-col justify-between bg-white shadow p-4 min-w-45 mt-4 md:mt-6 gap-2'>
      {MyAccountLinks.map((link) => (
        <li key={link.url}>
          <Link
            className='hover:text-neutrals-400 focus:text-accent-primary'
            data-cy={`my-account-${link.label.replaceAll(' ', '-').toLocaleLowerCase()}-navlink`}
            href={link.url}
          >
            {link.label}
          </Link>
        </li>
      ))}
      <li className='border-t-1 border-neutrals-200 mt-2 pt-4'>
        <SignOutButton />
      </li>
    </ul>
  );

  return disabled ? (
    <div className='flex flex-col justify-center cursor-not-allowed animate-pulse'>{trigger}</div>
  ) : (
    <BasicPopover
      align='end'
      className='group flex flex-col justify-center'
      content={content}
      trigger={trigger}
    />
  );
};
